import { useCallback, useRef } from 'react'

import {
  AlbumCollectionGate,
  albumCollectionByIdQuery,
} from '@/entities/album-collections'
import { type AuthorPreview } from '@/entities/authors'
import { ROUTES } from '@/shared/config'
import {
  ContentWrapper,
  ErrorResult,
  HeaderContent,
  HidingSpin,
} from '@/shared/ui'
import { AlbumCollectionForm } from '@/widgets/AlbumCollectionForm'
import { AuthorForm, authorFormModalOpened } from '@/widgets/AuthorForm'
import { Breadcrumb, Layout } from 'antd'
import { useUnit } from 'effector-react'
import { Link, useLocation, useParams } from 'react-router-dom'

export const AlbumCollectionEditPage = () => {
  const { id } = useParams<{ id: string }>()
  const albumCollection = useUnit(albumCollectionByIdQuery)
  const albumCollectionStatus = useUnit(albumCollectionByIdQuery.$status)

  const location = useLocation()
  const state = location.state as {
    author?: AuthorPreview
  }
  const author = state?.author

  const openAuthorsFormModal = useUnit(authorFormModalOpened)

  const onAuthorSubmitted = useRef<(id: string) => void>(() => {})
  const onAuthorButtonClick = useCallback(
    (callback: (id: string) => void) => {
      onAuthorSubmitted.current = callback
      openAuthorsFormModal()
    },
    [openAuthorsFormModal],
  )

  return (
    <Layout>
      {id && <AlbumCollectionGate id={id} />}
      <AuthorForm
        isModal
        onSubmitted={(authorId: string) => onAuthorSubmitted.current(authorId)}
      />
      <HidingSpin
        spinning={
          albumCollectionStatus === 'initial' ||
          (albumCollectionStatus === 'pending' &&
            !albumCollection.data &&
            !albumCollection.error)
        }
      >
        {albumCollection.data && !albumCollection.error ? (
          <>
            <HeaderContent
              breadcrumbSlot={
                <Breadcrumb
                  items={[
                    ...(author
                      ? [
                          { title: 'Авторы' },
                          {
                            title: (
                              <Link
                                to={ROUTES.AUTHORS.EDIT.replace(
                                  ':id',
                                  author.id,
                                )}
                              >
                                {author.nickname}
                              </Link>
                            ),
                          },
                        ]
                      : [
                          { title: 'Контент' },
                          { title: 'Коллекции' },
                          {
                            title: (
                              <Link to={ROUTES.COLLECTIONS.ALBUM_COLLECTIONS}>
                                Выпуски
                              </Link>
                            ),
                          },
                        ]),
                    {
                      title: albumCollection.data.name,
                    },
                  ]}
                />
              }
              title="Редактирование выпуска"
              description="Раздел предоставляет возможность добавлять новый контент в каталог и управлять его параметрами"
            />

            <ContentWrapper>
              <AlbumCollectionForm onAuthorButtonClick={onAuthorButtonClick} />
            </ContentWrapper>
          </>
        ) : (
          <ContentWrapper>
            <ErrorResult
              error={albumCollection.error}
              notFoundConfig={{
                subTitle: 'Данного выпуска не существует.',
                navigateTo: ROUTES.COLLECTIONS.ALBUM_COLLECTIONS,
              }}
            />
          </ContentWrapper>
        )}
      </HidingSpin>
    </Layout>
  )
}
